/**
 * Один разрыв на весь UI: десктоп начинается с 1024px.
 *
 * Используется через `useMediaQuery(DESKTOP_QUERY)` в местах, где
 * раскладка кардинально меняется (sidebar always-visible vs drawer).
 */

export const DESKTOP_MIN_WIDTH = 1024;
export const DESKTOP_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;
